import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import modalReducer from '@cred/react-modal/reducer'
import helpers from './helpers/reducer'

const components = combineReducers({
    modal: modalReducer,
  }),
  rootReducer = combineReducers({
    form: (data, action) => {
      const newAction = {
        ...action,
        payload: typeof action.payload === 'string' ? action.payload.replace(/^\s+/g, '') : action.payload,
      }
      return formReducer(data, newAction)
    },
    helpers,
    components,
  })

export default rootReducer
